import { createGlobalState } from 'react-hooks-global-state';
import { InputErrorObject } from '../../lib/types';

type BomRetryState = {
  retryCount: number;
  retriesExhausted: boolean;
  isRetryable: boolean;
  errorMessage?: string;
  sentryEventId?: string; // Sentry event ID for backend infrastructure errors
};

type GlobalStateType = {
  showDuplicateModal: boolean,
  cadTool?: string,
  checksComplete?: boolean,
  isSaving?: boolean,
  inputErrors?: InputErrorObject,
  bomRetryState?: Record<string, BomRetryState>, // Key: instanceId, Value: retry state
  unsavedInputs?: Set<string>, // Set of setting titles that have unsaved changes
  projectIdWithCompletedInitialCheck?: string, // Project ID that has completed the initial BOM check
};

const { useGlobalState } = createGlobalState<GlobalStateType>({
  showDuplicateModal: false,
  cadTool: 'Not set',
  checksComplete: false,
  isSaving: false,
  inputErrors: {},
  bomRetryState: {},
  unsavedInputs: new Set<string>(),
  projectIdWithCompletedInitialCheck: undefined,
});

export default useGlobalState;
